import NavBar from '@/components/Nav.vue';

import functions from '@/functions.js';
import enums from '@/configs/enums.js';

export default {
    name: 'EntityPage',
    components: {
        NavBar,
    },
    data() {
        return {
            type: 'normal',
            order: 'DESC',
            row: true,
            page: 1,
            more: true,
            loading: false,
            entities: [],
            types: enums.productType,
            dateFormat: functions.dateFormat,
            successType: '',
            openEntity: {},
            showEntity: {},
            showEntityAlter: false
        }
    },
    created() {
        this.getEntityList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getEntityList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                let params = {page: this.page, order: this.order, type: this.type};
                if (this.type == 'compose') {
                    params.compose = true;
                }
                this.$http.get('entity', {params: params}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    result.data.entities.forEach(entity => {
                        entity.showParent = ! entity.is_open && entity.product.parent != null;
                        entity.showCompose = entity.product.type == this.types.fragment && entity.can_compose && ! entity.is_composed;
                    });
                    this.entities = this.entities.concat(result.data.entities);
                })
            }
        },
        changeType(value) {
            this.type = value;
            this.page = 1;
            this.more = true;
            this.loading = false;
            this.entities = [];
            this.getEntityList();
        },
        toggleOrder() {
            this.order = this.order == 'DESC' ? 'ASC' : 'DESC';
            this.page = 1;
            this.more = true;
            this.loading = false;
            this.entities = [];
            this.getEntityList();
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getEntityList();
            }
        }
    }
}